<template>
<div class="leaderAndAddrDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="选择开团团长/提货点" :visible.sync="dialogVisible" width="650px">
        <el-tabs type="card"  v-model="activeName" addable @tab-click="handleChange"  @edit="handleTabsEdit" :class="[activeName=='leader'?'leader':'addr']">
            <el-tab-pane label="选择团长" name="leader">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                            <span>已选择<span class="tc-orange">{{leader.selectedResult.length}}</span>个团长</span>
                            <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入团长名称/联系号码" v-model="leader.param.key" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="leader.tableData" style="width: 100%" :show-header="true" ref="multipleTable1"
                                  @select="handleSelectionChange" @row-click="handleRowChange" @select-all="handleAllSelectionChange">
                            <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                            <el-table-column label="团长信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="imgbox">
                                            <img class="headerImg" v-lazy="scope.row.headerlogourl" alt>
                                        </div>
                                        <div>
                                            <div>
                                                <span class="innerbox">{{scope.row.headername}}</span>
                                                <span  class="innerbox">电话：{{scope.row.linktel}}</span>
                                            </div>
                                            <div>
                                                <span class="tc-grey innerbox">成员：{{scope.row.fanscount}}</span>
                                                <span class="tc-grey innerbox">提货点：{{scope.row.ppcount}}</span>
                                                <span class="tc-orange innerbox">团长佣金：{{scope.row.brokeragerateheader}}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination
                            background
                            @current-change="handleSizeChange"
                            :current-page.sync="leader.page.page"
                            :page-size="leader.page.pageSize"
                            :pager-count="11"
                            layout="prev, pager, next"
                            :total="leader.total">
                        </el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="选择提货点" name="addr">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                            <span>已选择<span class="tc-orange">{{addr.selectedResult.length}}</span>个提货点</span>
                            <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入团长名称/联系号码" v-model="addr.param.key" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="addr.tableData" style="width: 100%" :show-header="false" ref="multipleTable2"
                                  @select="handleSelectionChange" @row-click="handleRowChange">
                            <el-table-column type="selection" width="30"></el-table-column>
                            <el-table-column label="头像">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="imgbox">
                                            <img class="headerImg" v-lazy="scope.row.objrolelogo" alt v-if="scope.row.pptype==2">
                                            <img class="headerImg" v-lazy="brandBusiness.logourl" alt v-if="scope.row.pptype==1">
                                            <i class="icon icon_bb_tuan" v-if="scope.row.pptype==2"></i>
                                        </div>
                                        <div class="outbox">
                                            <div class="box">
                                                <span class="innerbox">{{scope.row.name}}</span>
                                                <span  class="innerbox" v-if="scope.row.pptype==2">{{scope.row.objrolename}}</span>
                                                <span  class="innerbox" v-if="scope.row.pptype==1">{{brandBusiness.hostname}}</span>
                                                <!--<span class="tc-red right-innerbox">累计销售：{{scope.row.objrolename}}</span>-->
                                            </div>
                                            <div class="box">
                                                <span class="tc-grey innerbox">{{scope.row.address}}</span>
                                                <!--<span class="tc-orange innerbox">团长佣金：{{scope.row.brokeragerateheader}}%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination
                            background
                            @current-change="handleSizeChange"
                            :current-page.sync="addr.page.page"
                            :page-size="addr.page.pageSize"
                            :pager-count="11"
                            layout="prev, pager, next"
                            :total="addr.total">
                        </el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

    </el-dialog>
    <addrDialog ref="addrDialog" @getList="getAddrList"></addrDialog>
    <invateDialog ref="invateDialog" @openLinkDialog="_openLinkDialog"></invateDialog>
    <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
</div>
</template>

<script>
import {getPickupPointListByEvent, getHostHeaderListByEvent} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import AddrDialog from 'views/brandBusiness/systemSetting/addr/components/addrDialog.vue'
import InvateDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateDialog.vue'
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
export default {
    name: 'leaderAndAddrDialog',
    data() {
        return {
            dialogVisible: false,
            activeName: 'leader',
            leader: {
                param: {
                    eventid: '',
                    hostroletype: '',
                    key: '',
                    status: '1'
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
                selectedResult: [],
            },
            addr:{
                param: {
                    eventid: '',
                    key: '',
                    pptype: '',
                    status: '1'
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
                selectedResult: []
            }
        }
    },
    mounted() {
    },
    methods: {
        selectable(row, index) {
            return !!row.isdelete
        },
        _openLinkDialog(inviteurlurl) {
            this.$refs.invateLinkDialog.openDialog(inviteurlurl)
        },
        handleTabsEdit(targetName, action) {
            if (action === 'add') {
                if (this.activeName == 'leader') {
                    this.$refs.invateDialog.openDialog()
                } else {
                    this.$refs.addrDialog.openDialog()
                }
            }
        },
        getAddrList() {
            this.activeName = 'addr'
            this._getList2()
        },
        handleChange() {
            if (this.activeName == 'leader') {
              this._getList()
            } else {
                this._getList2()
            }
        },
        handleCheck() {
            if (this.activeName == 'leader') {
                this.leader.tableData.forEach(obj => {
                    if (obj.isdelete && obj.isCheck) {
                        this._changeSelection(obj)
                        this.$refs.multipleTable1.toggleRowSelection(obj, false)
                    }
                })
                let list = []
                this.leader.selectedResult.forEach(obj => {
                    if (obj.isopenevent) {
                        list.push(obj)
                    }
                })
                this.leader.selectedResult = list
            } else {
                this.addr.tableData.forEach(obj => {
                    obj.isCheck = false
                })
                this.$refs.multipleTable2.clearSelection()
                this.addr.selectedResult = []
            }
        },
        handleSizeChange() {
            if (this.activeName == 'leader') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        openDialog(headerlist, ppidlist, eventid) {
            this.leader.param.eventid = eventid
            this.addr.param.eventid = eventid
            this.leader.tableData = []
            this.addr.tableData = []
            this.dialogVisible = true
            this.leader.selectedResult = this._.cloneDeep(headerlist)
            this.addr.selectedResult = ppidlist ? ppidlist.split(',') : []
            this._getList()
        },
        cancel() {
            this.leader.tableData = []
            this.addr.tableData = []
            this.leader.page.page = 1
            this.addr.page.page = 1
            this.leader.param.key = ''
            this.addr.param.key = ''
            this.activeName = 'leader',
            this.dialogVisible = false
        },
        handelQuery() {
            if (this.activeName == 'leader') {
                this.leader.page.page = 1
                this.leader.tableData = []
                this._getList()
            } else {
                this.addr.page.page = 1
                this.addr.tableData = []
                this._getList2()
            }
        },
        _getList() {
            this.setLoading(true)
            getHostHeaderListByEvent({
                data: Object.assign({}, this.leader.param, this.leader.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.leader.tableData = data.data.content
                    this.$nextTick(() => {
                        this.leader.selectedResult.forEach((obj, i) => {
                            this.leader.tableData.forEach((obj2, j) => {
                                if (obj.headerid === obj2.headerinnerid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable1.toggleRowSelection(this.leader.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.leader.total = data.data.pageinfo.rowCount
                    this.leader.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList2() {
            this.setLoading(true)
            getPickupPointListByEvent({
                data: Object.assign({}, this.addr.param, this.addr.page),
                success: data => {
                    data.data.datalist.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.addr.tableData = data.data.datalist
                    this.$nextTick(() => {
                        this.addr.selectedResult.forEach((obj, i) => {
                            this.addr.tableData.forEach((obj2, j) => {
                                if (obj === obj2.ppinnerid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable2.toggleRowSelection(this.addr.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.addr.total = data.data.pageinfo.rowCount
                    this.addr.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        handleAllSelectionChange(selection) {
            if (this.activeName == 'leader') {
                this.leader.tableData.forEach((obj, i) => {
                    if (obj.isdelete) {
                        this._changeSelection(obj)
                    }
                })
            } else {
                this.addr.tableData.forEach((obj, i) => {
                    this._changeSelection(obj)
                })
            }
        },
        handleSelectionChange(selection, row) {
            this._changeSelection(row)
        },
        handleRowChange(row) {
            row.isCheck = !row.isCheck
            if (this.activeName == 'leader') {
                if (row.isCheck) {
                    this.$refs.multipleTable1.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable1.toggleRowSelection(row, false)
                }
            } else {
                if (row.isCheck) {
                    this.$refs.multipleTable2.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable2.toggleRowSelection(row, false)
                }
            }
            this._changeSelection(row)
        },
        _changeSelection(row) {
            if (this.activeName == 'leader') {
                row.isCheck = !row.isCheck
                if (row.isCheck) {
                    let obj = {
                        headerid: row.headerinnerid,
                        isopenevent: !row.isdelete,
                        pplist: ''
                    }
                    this.leader.selectedResult.push(obj)
                } else {
                    this.leader.selectedResult.forEach((obj1, index1) => {
                        if (obj1.headerid === row.headerinnerid) {
                            this.leader.selectedResult.splice(index1, 1)
                        }
                    })
                }
            } else {
                row.isCheck = !row.isCheck
                if (row.isCheck) {
                    this.addr.selectedResult.push(row.ppinnerid)
                } else {
                    this.addr.selectedResult.forEach((obj1, index1) => {
                        if (obj1 === row.ppinnerid) {
                            this.addr.selectedResult.splice(index1, 1)
                        }
                    })
                }
            }
        },
        handleSure() {
            // if (!this.leader.selectedResult.length) {
            //     this.$message.error('请选择团长')
            //     this.activeName = 'leader'
            //     return false
            // } else
                if (!this.addr.selectedResult.length) {
                this.$message.error('请选择提货点')
                this.activeName = 'addr'
                if (!this.addr.tableData.length) this._getList2()
                return false
            }
            this.$emit('setLeaderAddrList', this.leader.selectedResult, this.addr.selectedResult.join(','))
            this.cancel()
        },
        ...mapActions([
            'setLoading', 'setBrandBusiness'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user', 'brandBusiness'
        ])
    },
    components: {
        AddrDialog, InvateLinkDialog, InvateDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.leaderAndAddrDialog {
    display: flex;
    .right_main_box {
        width: 100%;
    }
    .search_box {
        display: flex;
        margin-bottom: 10px;
        justify-content: space-between;
        .innerbox {
            display: flex;
            align-items: center;
        }
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 32px;
        }
        .el-input__icon {
            line-height: 32px;
        }
        .el-button,
        .el-button--mini {
            height: 32px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table {
            min-height: 340px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 42px;
            box-sizing: border-box;
            .headerImg {
                width: 50px;
                height: 50px;
            }
            .innerbox {
                margin-right: 20px;
            }
            .imgbox{
                position: relative;
                margin-right: 20px;
                .icon{
                    position: absolute;
                    bottom: 0;
                    right:-2px;
                    &:before{
                        width: 16px;
                        height: 16px;
                    }
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-table::before {
        height: 0;
    }
    .el-tabs__new-tab{
        width: 100px;
        border-width: 0;
        color: #606266;
        font-size: 14px;
        &:hover{
            color: #409EFF;
        }
        .el-icon-plus:before{
            content: '';
        }
    }
    .leader .el-tabs__new-tab:after{
        content: '邀请团长';
    }
    .addr .el-tabs__new-tab:after{
        content: '+ 提货点';
    }
    .el-table__body-wrapper{
        height: 350px;
        overflow-y: auto !important;
    }
}
</style>
